/*  ==========================================================================
    MODULES
    Collection of all modules

    INFO:
    - try to program each module reusable-friendly if possible
    ========================================================================== */

/*
 * IMPORTS
 */

// import * as additionalsListView from "./lib/additionals-list-view";
import * as buttons from "./lib/buttons";
// import * as ccArticle from "./lib/cc-article";
// import * as ccListView from "./lib/cc-list-view";
import * as downloadList from "./lib/download-list";
// import * as downloadboxes from "./lib/downloadboxes";
// import * as freeroomsListView from "./lib/freerooms-list-view";
// import * as gallery from "./lib/gallery";
import * as images from "./lib/images";
// import * as impressions from "./lib/impressions"
import * as impressionsV2 from "./lib/impressions-v2";
// import * as impressionsV3 from "./lib/impressions-v3";
// import * as impressionsV4 from "./lib/impressions-v4";
import * as offerDetail from "./lib/offer-detail";
import * as offersListView from "./lib/offers-list-view";
// import * as offersListViewV2 from "./lib/offers-list-view-v2";
// import * as offersTeaser from "./lib/offers-teaser";
// import * as priceOverview from "./lib/price-overview";
import * as roomDetail from "./lib/room-detail";
import * as roomsListView from "./lib/rooms-list-view";
// import * as roomsListViewV2 from "./lib/rooms-list-view-v2";
// import * as roomsListViewV3 from "./lib/rooms-list-view-v3";
import * as routePlanner from "./lib/route-planner";
import * as slideBox from "./lib/slide-box";
import * as text from "./lib/text";
// import * as textPicBox from "./lib/text-pic-box";
import * as textPicBoxV2 from "./lib/text-pic-box-v2";
// import * as textPicBoxV3 from "./lib/text-pic-box-v3";
// import * as textPicBoxV4 from "./lib/text-pic-box-v4";
// import * as weatherDetail from "./lib/weather-detail";
import * as linkBoxes from "./lib/linkboxes";
// import * as linkBoxesV2 from "./lib/linkboxes_v2";


/*
 * EXPORTS
 */

export {
    // additionalsListView,
    buttons,
    // ccArticle,
    // ccListView,
    downloadList,
    // downloadboxes,
    // freeroomsListView,
    // gallery,
    images,
    // impressions,
    impressionsV2,
    // impressionsV3,
    // impressionsV4,
    offerDetail,
    offersListView,
    // offersListViewV2,
    // offersTeaser,
    // priceOverview,
    roomDetail,
    roomsListView,
    // roomsListViewV2,
    // roomsListViewV3,
    routePlanner,
    slideBox,
    text,
    // textPicBox,
    textPicBoxV2,
    // textPicBoxV3,
    // textPicBoxV4,
    // weatherDetail,
    linkBoxes,
    // linkBoxesV2
};



// WEBPACK FOOTER //
// ./source/js/modules/modules.js